<script lang="ts">
  import Header from "./components/Header.svelte";
  import Hero from "./components/Hero.svelte";
  import Features from "./components/Features.svelte";
  import Screenshot from "./components/Screenshot.svelte";
  import QuickStart from "./components/QuickStart.svelte";
  import Abstract from "./components/Abstract.svelte";
  import Footer from "./components/Footer.svelte";
</script>

<Header />
<main id="main-content">
  <Hero />
  <QuickStart />
  <Screenshot />
  <Abstract />
  <Features />
</main>
<Footer />
